module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_4.725fe40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_4.jpg
// module id = uSXj
// module chunks = 0